import {VStack, Grid} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {MainCategoryProps} from '../../../types/ConditionTypes';
import {CategoryCard} from './CategoryCard';

export const Documentation = ({
  data: categoryStructure,
  ...rest
}: MainCategoryProps & TestIdProps) => {
  const childCategories = categoryStructure?.childCategories;
  const halfOffset = Math.round((childCategories?.length ?? 0) / 1.7);
  const leftColumnCategories = childCategories?.slice(0, halfOffset);
  const rightColumnCategories = childCategories?.slice(halfOffset, childCategories.length);

  return (
    <Grid columns={[1, 2]}>
      <VStack spacing={4}>
        {leftColumnCategories?.map((category, index) => (
          <CategoryCard
            key={`left-${category.id}-${category.uniqueKey}`}
            data={category}
            cardVariant="inlineGrey"
            data-testid={suffixTestId(`left-[${index}]`, rest)}
          />
        ))}
      </VStack>
      <VStack spacing={4}>
        {rightColumnCategories?.map((category, index) => (
          <CategoryCard
            key={`right-${category.id}-${category.uniqueKey}`}
            data={category}
            cardVariant="inlineGrey"
            data-testid={suffixTestId(`right-${index}`, rest)}
          />
        ))}
      </VStack>
    </Grid>
  );
};
